import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "post_media__transcript"
}
const _hoisted_2 = {
  key: 0,
  class: "transcript-segments"
}
const _hoisted_3 = { class: "transcript-segment__time" }
const _hoisted_4 = { class: "transcript-segment__text" }
const _hoisted_5 = {
  key: 1,
  class: "transcript-simple"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_message = _resolveComponent("message")!
  const _component_modal = _resolveComponent("modal")!
  const _directive_dompurify_html = _resolveDirective("dompurify-html")!

  return (_openBlock(), _createBlock(_component_modal, {
    title: "Transcript",
    ref: "modal"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_loader, { task: _ctx.task }, null, 8, ["task"]),
      (_ctx.transcript)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_ctx.hasSegments)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transcript.segments, (segment) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: segment.id || segment.startTime,
                      class: "transcript-segment"
                    }, [
                      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.formatTime(segment.startTime)), 1),
                      _withDirectives(_createElementVNode("span", _hoisted_4, null, 512), [
                        [_directive_dompurify_html, _ctx.highlightText(segment.text), "postContent"]
                      ])
                    ]))
                  }), 128))
                ]))
              : (_ctx.content)
                ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, null, 512)), [
                    [_directive_dompurify_html, _ctx.content, "postContent"]
                  ])
                : (_openBlock(), _createBlock(_component_message, { key: 2 }, {
                    default: _withCtx(() => [
                      _createTextVNode("No transcript available.")
                    ]),
                    _: 1
                  }))
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 512))
}